var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgS4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 51C39.5833 51 51 39.5833 51 25.5C51 11.4167 39.5833 0 25.5 0C11.4167 0 0 11.4167 0 25.5C0 39.5833 11.4167 51 25.5 51Z",
    fill: "#FFCC4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9023 33.4637C14.9661 33.7173 16.557 39.6673 25.5061 39.6673C34.4566 39.6673 36.0461 33.7173 36.1098 33.4637C36.1878 33.1563 36.0489 32.8376 35.7741 32.6789C35.4978 32.5217 35.1522 32.5684 34.9241 32.788C34.8972 32.8149 32.1559 35.4173 25.5061 35.4173C18.8563 35.4173 16.1136 32.8149 16.0881 32.7894C15.9521 32.6548 15.7708 32.584 15.5894 32.584C15.4704 32.584 15.35 32.6137 15.2409 32.6746C14.9633 32.8333 14.8244 33.1549 14.9023 33.4637Z",
    fill: "#664500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0046 24.0837C18.9606 24.0837 20.5462 21.8637 20.5462 19.1253C20.5462 16.3869 18.9606 14.167 17.0046 14.167C15.0485 14.167 13.4629 16.3869 13.4629 19.1253C13.4629 21.8637 15.0485 24.0837 17.0046 24.0837Z",
    fill: "#664500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0046 24.0837C35.9606 24.0837 37.5462 21.8637 37.5462 19.1253C37.5462 16.3869 35.9606 14.167 34.0046 14.167C32.0485 14.167 30.4629 16.3869 30.4629 19.1253C30.4629 21.8637 32.0485 24.0837 34.0046 24.0837Z",
    fill: "#664500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS4);
export default __webpack_public_path__ + "static/media/s4.86c12d6e323f13fbe747ba518369d221.svg";
export { ForwardRef as ReactComponent };